'use client';

import React, { useEffect, useRef } from 'react';

export function FormIndicator() {
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const form = divRef.current?.closest('form');
    if (form) {
      form.addEventListener('focusin', (e) => {
        if (e.target instanceof HTMLInputElement) {
          const element = divRef.current as HTMLDivElement;
          element.style.display = 'block';
          element.style.position = 'absolute';
          e.target.parentElement?.appendChild(element);
        }
      });
      form.addEventListener('focusout', () => {
        const element = divRef.current as HTMLDivElement | undefined;
        if (element) element.style.display = 'none';
      });
    }

    return () => {
      form?.removeEventListener('focus', () => undefined);
    };
  }, []);

  return (
    <div
      className="inset-x-[-18px] inset-y-[calc(50%-8px)] hidden w-fit"
      ref={divRef}
      data-testid="input-indicator"
    >
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 2050">
          <g id="Vector">
            <path
              d="M20.9712 5.9698C22.0349 6.94758 22.0349 9.05243 20.9712 10.0302L15.0382 15.4839C13.8199 16.6038 12.1641 15.4342 12.1641 13.4537V2.54632C12.1641 0.565781 13.8199 -0.60382 15.0382 0.516107L20.9712 5.9698Z"
              fill="#3768B1"
            />
            <path
              d="M0.230469 2.46154C0.230469 1.10207 1.05245 0 2.06641 0H14C15.014 0 15.836 1.10207 15.836 2.46154V13.5385C15.836 14.8979 15.014 16 14 16H2.06641C1.05245 16 0.230469 14.8979 0.230469 13.5385V2.46154Z"
              fill="#3768B1"
            />
          </g>
          <g id="Group 2049">
            <path
              id="Vector_2"
              d="M9.72006 2.46143L8.26367 4.12587L11.6541 7.99989L8.26367 11.8739L9.72006 13.5383L14.5655 7.99989L9.72006 2.46143Z"
              fill="white"
            />
            <path
              id="Vector_3"
              d="M4.91732 13.5383L9.76279 7.99989L4.91732 2.46143L3.46094 4.12587L6.85139 7.99989L3.46094 11.8739L4.91732 13.5383Z"
              fill="white"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
